module.exports = __webpack_public_path__ + "img/sun.1f574ece.svg";